import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class StripeInvoiceQueryService {

    public CREATE_STRIPE_INVOICE_DATA: any;
    public GET_STRIPE_INVOICE: any;

    constructor(public apollo: Apollo) {
        // Create invoice
        this.CREATE_STRIPE_INVOICE_DATA = gql` 
            mutation CREATE_INSPECTION_REPORT_MUTATION($input: CreateStripeinvoiceInput!) {
                 createStripeinvoice(input: $input) {
                        stripeinvoice{
                                orderId        
                        }
                }
            }
        `;

        //get all invoice details
        this.GET_STRIPE_INVOICE =
            gql`     
       query getAllStripes{                                       
             allStripeinvoices {
                     nodes {
                        orderId
                        invoiceObject
                        chargeObject
                        invoiceid
                        id
                     }
             }
         }
     `;
    }

    // Create invoice
    CREATE_STRIPE_INVOICE_DATA_MUTATION(orderId, invoice) {
        return this.apollo.mutate({
            mutation: this.CREATE_STRIPE_INVOICE_DATA,
            variables: {
                "input": {
                    "stripeinvoice": {
                        "orderId": Number.parseInt(orderId),
                        "invoiceObject": JSON.stringify(invoice),
                    }
                }
            },
        })
    }

    //get all invoice details
    GET_ALL_STRIPE_INVOICES(): any {
        return this.apollo
            .watchQuery({
                query: this.GET_STRIPE_INVOICE,
                fetchPolicy: 'network-only'
            });
    }

}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/stripeInvoices.ts